(function () {
  'use strict';

  const published = new Set();

  function publish(name, data, onceKey) {
    if (onceKey && published.has(onceKey)) return;
    if (onceKey) published.add(onceKey);
    const payload = Object.assign({
      path: window.location.pathname,
      page_type: document.body && Array.from(document.body.classList).find(c => c.indexOf('template-') === 0) || 'unknown',
      timestamp: new Date().toISOString()
    }, data || {});
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('carrco:' + name, payload);
      }
    } catch (error) {
      if (window.console && console.debug) console.debug('[Carrco analytics]', error);
    }
  }

  function builderState() {
    try {
      const debug = window._ccDebug && window._ccDebug();
      if (!debug || !debug.state) return {};
      return {
        width: debug.state.w,
        height: debug.state.h,
        quantity: debug.state.q,
        finish: debug.state.finish
      };
    } catch (_) { return {}; }
  }

  document.addEventListener('carrco:analytics', function (event) {
    if (!event.detail || !event.detail.name) return;
    publish(event.detail.name, event.detail.data || {});
  });

  document.addEventListener('click', function (event) {
    const target = event.target.closest('a,button');
    if (!target) return;

    if (target.matches('.cc-next__button,.cc-brand-footer__lead>a')) {
      publish('primary_cta_clicked', { label: target.textContent.trim(), destination: target.getAttribute('href') });
    }
    if (target.matches('.cc-product-tile')) {
      publish('product_tile_clicked', { product: target.querySelector('h2')?.textContent.trim(), destination: target.getAttribute('href') });
    }
    if (target.matches('.cc-qty-btn,.cc-finish-btn')) {
      window.setTimeout(function () { publish('configuration_changed', builderState()); }, 0);
    }
    if (target.matches('#cc-add-to-cart')) {
      publish('custom_order_cta_clicked', builderState());
    }
    if (target.matches('.cc7-quickstart__routes a,.cc2-start--priority .cc2-path')) {
      publish('decision_route_clicked', {
        label: target.querySelector('b,h3')?.textContent.trim() || target.textContent.trim(),
        destination: target.getAttribute('href')
      });
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('#cc-w,#cc-h')) publish('configuration_changed', builderState());
  });

  const observer = new MutationObserver(function () {
    const uploaded = Array.from(document.querySelectorAll('input[name^="properties["]')).some(function (input) {
      return /^https?:\/\//.test((input.value || '').trim());
    });
    if (uploaded) publish('artwork_uploaded', builderState(), 'artwork-uploaded');
  });

  document.addEventListener('DOMContentLoaded', function () {
    publish('theme_ready', { theme_system: 'carrco-next' }, 'theme-ready');
    observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });

    const currentPath = window.location.pathname.replace(/\/$/, '') || '/';

    /* The fastest route to an order should never sit below editorial content.
       Put the existing home decision grid directly beneath the proof bar and
       repair the obsolete bulk-order route wherever it appears. */
    document.querySelectorAll('a[href="/pages/bulk-orders"],a[href^="/pages/bulk-orders#"]').forEach(function (link) {
      link.setAttribute('href', link.getAttribute('href').replace('/pages/bulk-orders', '/pages/bulk-stickers'));
    });

    const home = document.querySelector('.cc2-home');
    const homeProof = home && home.querySelector('.cc2-proofbar');
    const homeStart = home && home.querySelector('.cc2-start');
    if (homeProof && homeStart) {
      homeProof.insertAdjacentElement('afterend', homeStart);
      homeStart.classList.add('cc2-start--priority');
      homeStart.id = homeStart.id || 'start-order';
    }

    /* Keep Uploadly's own component and behavior, but dock it inside the
       artwork workspace on desktop. Return it to the native product block
       order on smaller screens so the ordering remains easy to scan. */
    const setupArtworkWorkspace = function () {
      const studio = document.querySelector('.cc-studio2');
      const info = studio && studio.closest('.product__info-container');
      const upload = info && Array.from(info.querySelectorAll('.shopify-app-block')).find(function (block) {
        return block.querySelector('shopify-app-block-uploadly, input[type="file"], input[name^="properties["]');
      });
      const preview = studio && studio.querySelector('.cc-studio2__preview');
      const body = studio && studio.querySelector('.cc-studio2__body');
      const config = studio && studio.querySelector('.cc-studio2__config');
      const cta = info && info.querySelector(':scope > .cc-cta-wrap');
      const desktop = window.matchMedia('(min-width: 1051px)');

      if (!studio || !upload || !preview || !body) return false;

      upload.classList.add('cc-upload-workspace');
      if (!upload.querySelector('.cc7-upload-confidence')) {
        const uploadConfidence = document.createElement('div');
        uploadConfidence.className = 'cc7-upload-confidence';
        uploadConfidence.setAttribute('aria-label', 'Artwork and proof assurance');
        uploadConfidence.innerHTML = '<strong>Not sure the file is perfect? Send it anyway.</strong><span>Human file check</span><span>Free proof before print</span><span>Nothing prints without approval</span>';
        upload.appendChild(uploadConfidence);
      }

      const placeUpload = function () {
        if (desktop.matches) {
          let column = body.querySelector('.cc-studio2__artwork-column');
          if (!column) {
            column = document.createElement('div');
            column.className = 'cc-studio2__artwork-column';
            body.insertBefore(column, preview);
          }
          if (preview.parentElement !== column) column.appendChild(preview);
          if (upload.parentElement !== column) column.appendChild(upload);
          studio.classList.add('cc-studio2--upload-docked');
        } else {
          const column = body.querySelector('.cc-studio2__artwork-column');
          if (column) {
            body.insertBefore(preview, config || null);
            column.remove();
          }
          if (info) info.insertBefore(upload, cta || null);
          studio.classList.remove('cc-studio2--upload-docked');
        }
      };

      placeUpload();
      if (!studio.dataset.ccWorkspaceBound) {
        studio.dataset.ccWorkspaceBound = 'true';
        if (desktop.addEventListener) desktop.addEventListener('change', placeUpload);
        else desktop.addListener(placeUpload);
      }
      return true;
    };

    if (!setupArtworkWorkspace()) {
      [350, 1000, 2200, 4500].forEach(function (delay) {
        window.setTimeout(setupArtworkWorkspace, delay);
      });
    }

    /* Turn the label knowledge pages into one visual system without changing
       the merchant-authored page records. Everything here remains scoped to
       the unpublished theme and can be reviewed before the theme is published. */
    const knowledge = document.querySelector('.ccx');
    if (knowledge) {
      const path = currentPath;
      const industryPages = {
        '/pages/honey-labels': { key: 'food', caption: 'Honey & pantry labels', alt: 'Premium printed labels on a honey jar and hot sauce bottle' },
        '/pages/sauce-labels': { key: 'food', caption: 'Sauce & pantry labels', alt: 'Waterproof printed labels on food jars and sauce bottles' },
        '/pages/beer-labels': { key: 'beverage', caption: 'Craft beverage labels', alt: 'Custom printed label on a craft beverage can' },
        '/pages/wine-labels': { key: 'beverage', caption: 'Wine & bottle labels', alt: 'Premium custom printed label on a wine bottle' },
        '/pages/coffee-labels': { key: 'beverage', caption: 'Coffee packaging labels', alt: 'Custom printed label on premium coffee packaging' },
        '/pages/candle-labels': { key: 'beauty', caption: 'Candle & vessel labels', alt: 'Premium printed label on an amber candle jar' },
        '/pages/spa-beauty-labels': { key: 'beauty', caption: 'Beauty & skincare labels', alt: 'Waterproof custom labels on beauty and skincare packaging' },
        '/pages/cannabis-labels': { key: 'wellness', caption: 'Compliant wellness labels', alt: 'Professional custom labels on wellness packaging' }
      };
      const industry = industryPages[path];

      if (industry && knowledge.querySelector('.ccx-hero')) {
        knowledge.classList.add('ccx--industry', 'ccx--' + industry.key);
        const heroVisual = knowledge.querySelector('.ccx-hero-r');
        if (heroVisual && !heroVisual.querySelector('.ccx-industry-visual')) {
          const figure = document.createElement('figure');
          figure.className = 'ccx-industry-visual';
          figure.setAttribute('role', 'img');
          figure.setAttribute('aria-label', industry.alt);
          figure.innerHTML = '<figcaption><b>Printed proof</b><span>' + industry.caption + '</span></figcaption>';
          heroVisual.insertBefore(figure, heroVisual.firstChild);
        }
      }

      if (path === '/pages/resources' && knowledge.querySelector('.ccx-rhero')) {
        knowledge.classList.add('ccx--resources');
        const heading = knowledge.querySelector('.ccx-rh1');
        if (heading) heading.innerHTML = 'Everything we know<br>about <em>stickers &amp; labels.</em>';

        if (!knowledge.querySelector('.ccx-resource-visuals')) {
          const library = document.createElement('section');
          library.className = 'ccx-resource-visuals';
          library.setAttribute('aria-label', 'Product label guides by industry');
          library.innerHTML =
            '<div class="ccx-w"><div class="ccx-resource-visuals__head"><p>Label field guides</p><h2>Built for the package it lives on.</h2><span>Choose an industry to see material, finish, sizing and application recommendations.</span></div>' +
            '<div class="ccx-resource-visuals__grid">' +
              '<a class="ccx-resource-visual ccx-resource-visual--food" href="/pages/honey-labels"><b>Food &amp; pantry</b><span>Honey, sauce and refrigerated goods</span></a>' +
              '<a class="ccx-resource-visual ccx-resource-visual--beverage" href="/pages/beer-labels"><b>Beverage &amp; coffee</b><span>Beer, wine and specialty coffee</span></a>' +
              '<a class="ccx-resource-visual ccx-resource-visual--beauty" href="/pages/spa-beauty-labels"><b>Beauty &amp; candle</b><span>Skincare, bath and vessel labels</span></a>' +
              '<a class="ccx-resource-visual ccx-resource-visual--wellness" href="/pages/cannabis-labels"><b>Wellness packaging</b><span>Professional, durable and compliant</span></a>' +
            '</div></div>';
          knowledge.querySelector('.ccx-rhero').insertAdjacentElement('afterend', library);
        }
      }
    }

    /* Reusable decision console for high-intent education and industry pages.
       It converts empty post-hero space into direct buying routes and the four
       confidence answers customers otherwise have to hunt for. */
    const quickstartPaths = new Set([
      '/pages/materials',
      '/pages/resources',
      '/pages/printing-guide',
      '/pages/how-to-order',
      '/pages/faq',
      '/pages/bulk-stickers',
      '/pages/honey-labels',
      '/pages/sauce-labels',
      '/pages/beer-labels',
      '/pages/wine-labels',
      '/pages/coffee-labels',
      '/pages/candle-labels',
      '/pages/spa-beauty-labels',
      '/pages/cannabis-labels'
    ]);

    if (quickstartPaths.has(currentPath) && !document.querySelector('.cc7-quickstart')) {
      let quickstartTarget = null;
      if (knowledge && knowledge.querySelector('.ccx-hero')) quickstartTarget = knowledge.querySelector('.ccx-hero');
      else if (knowledge && knowledge.querySelector('.ccx-rhero')) quickstartTarget = knowledge.querySelector('.ccx-rhero');
      else if (document.querySelector('.cc-materials__hero')) quickstartTarget = document.querySelector('.cc-materials__hero');
      else if (document.querySelector('.cc4-page__hero')) quickstartTarget = document.querySelector('.cc4-page__hero');

      if (quickstartTarget) {
        const quickstart = document.createElement('section');
        quickstart.className = 'cc7-quickstart';
        quickstart.id = 'fastest-path';
        quickstart.setAttribute('aria-label', 'Fastest paths to order stickers and labels');
        quickstart.innerHTML =
          '<div class="cc7-quickstart__inner">' +
            '<header class="cc7-quickstart__head"><span>Fastest path</span><strong>Choose what you need.</strong><small>One click gets you to the right pricing or catalog.</small></header>' +
            '<nav class="cc7-quickstart__routes" aria-label="Choose an order type">' +
              '<a href="/products/custom-shape-stickers"><i>01</i><b>Custom stickers</b><span>Upload artwork · any shape</span><em>Price now ↗</em></a>' +
              '<a href="/pages/product-labels"><i>02</i><b>Product labels</b><span>Bottles, jars &amp; packaging</span><em>Choose format ↗</em></a>' +
              '<a href="/collections/all-stickers"><i>03</i><b>One-off stickers</b><span>2,000+ ready-made designs</span><em>Shop designs ↗</em></a>' +
              '<a href="/pages/bulk-stickers"><i>04</i><b>Bulk &amp; repeat</b><span>High volume · multiple designs</span><em>Plan a run ↗</em></a>' +
            '</nav>' +
            '<div class="cc7-quickstart__proof"><span>Free digital proof</span><span>No setup fees</span><span>25-piece minimum</span><span>Human file review</span></div>' +
          '</div>';
        quickstartTarget.insertAdjacentElement('afterend', quickstart);
      }
    }
  });
})();
